<template>
	<div class="videolist">
		<div class="breadcrumb">短视频列表</div>
		<div class="searchBtn" style="border:none;display:flex">
			<el-button size='small' type="primary" icon="el-icon-plus" @click="add" plain>添加</el-button>
			<el-button size='small' type="danger" @click="del" plain>删除</el-button>
			<div class="topinput">
				<input type="text" v-model="searchVideo" class="el-input__inner" placeholder="视频标题" @keyup.enter="search_mine">
			</div>
			<el-date-picker
		      	v-model="timeVal"
	      		type="daterange"
	      		range-separator=" 至 "
	      		start-placeholder="课程开始日期"
	      		end-placeholder="课程结束日期"
      			value-format="yyyy-MM-dd">
		    </el-date-picker>
		    <el-button type="primary" @click="search_mine">搜索</el-button>
	    </div>
	    <div class="topnav" style="margin:15px 0 20px">
	    	<li v-for="(item,index) in selData" :class="index==cur?'active':''" @click="topnav(index,item.id)">{{item.name}}</li>
	    </div>
	    <el-table ref="multipleTable" :data="tableData3" highlight-current-row  style="width: 100%" @current-change="handleCurrentChange">
		    <el-table-column prop="id" label="ID"></el-table-column>
		    <el-table-column prop="videoDesc" label="视频标题">
		    </el-table-column>
		    <el-table-column prop="videoUrl" label="视频">
		    	<template slot-scope="scope">
		    		<el-button type="primary" size="small" @click="watchVideo(scope.row.videoUrl)" v-if="scope.row.videoUrl">观看视频</el-button>
		    	</template>
		    </el-table-column>
		    <el-table-column prop="coverUrl" label="封面">
		      	<template slot-scope="scope">
	            	<div class="imgWidth" v-if="scope.row.coverUrl">
	            		<img :src="scope.row.coverUrl"  />
	            	</div>
	            </template>
		    </el-table-column>
		    <el-table-column prop="coachName" label="教练名称"></el-table-column>
		    <el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建时间">
		    </el-table-column>
		    <el-table-column prop="status" label="操作" width='300' >
		    	<template slot-scope="scope">
		    		<el-button type="primary" size='small' v-if="scope.row.status==1 || scope.row.status==0" @click="checkShortVideo(scope.row,2)" v-has="'short_video_operation'">审核通过</el-button>
					<el-button type="danger" size='small' v-if="scope.row.status==1 || scope.row.status==2" @click="checkShortVideo(scope.row,0)" v-has="'short_video_operation'">审核不通过</el-button>
					<el-button type="primary" size='small' @click="comments(scope.row)" v-if="scope.row.status==2">评论</el-button>
					<el-button :type="scope.row.isTop==0?'primary':'danger'" size='small' @click="videoStick(scope.row)" v-if="scope.row.status==2" v-has="'short_video_operation'">{{scope.row.isTop==0?'置顶':'取消置顶'}}</el-button>
		    	</template>
		    </el-table-column>
		</el-table>
	  	<div style="margin-top: 20px">
	    	<div style="float:right">
			    <el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
			</div>
		</div>
		<!-- 请选择用户 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="120px">
		        <el-form-item label="视频标题" prop="videoDesc">
		          	<el-input v-model="ruleForm.videoDesc" placeholder="请输入标题" style="width: 80%;"></el-input>
		        </el-form-item>
			  	<el-form-item label="请选择教练" prop="coachId" class="selectUser" >
	          		<i class="el-icon-edit" v-if="!setcoachId || setcoachId=='undefined'"></i>
	          		<label @click="selCoachesDialog()" v-if="!setcoachId || setcoachId=='undefined'">{{ruleForm.nickname}}</label>

	          		<label v-if="ruleForm.nickname && setcoachId!='undefined'">{{ruleForm.nickname}}</label>
	          		<el-input v-model="ruleForm.coachId" v-show="isShow"></el-input>
	        	</el-form-item>
		        <el-form-item label="上传视频" class="video-upload" prop="videoUrl">
	          		<el-input v-model="ruleForm.videoUrl" placeholder style="width: 80%;"></el-input>
	          		<el-upload class="avatar-uploader" :action="tmpFilesv" accept=".mp4, .qlv, .qsv, .ogg, .flv, .avi, .wmv, .rmvb" :show-file-list="false" :before-upload="beforeUploadVideo" :on-success="handleVideoSuccess" :on-progress="uploadVideoProcess">
	            		<video v-if="ruleForm.videoUrl !='' && videoFlag == false" :src="ruleForm.videoUrl" width="350" height="180" controls="controls">您的浏览器不支持视频播放</video>
			            <i v-else-if="ruleForm.videoUrl =='' && videoFlag == false" class="el-icon-plus avatar-uploader-icon"></i>
			            <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent" style="margin-top:30px"></el-progress>
	          		</el-upload>
	        	</el-form-item>
	        	<!-- 上传图片 -->
		        <el-form-item label="选择封面" prop="coverUrl">
		          	<el-input v-model="ruleForm.coverUrl" placeholder style="width: 80%;"></el-input>
		          	<el-upload class="avatar-uploader" :action="tmpFiles" :show-file-list="false" :headers="headers" :on-success="handleAvatarSuccess" >
		            	<img v-if="ruleForm.coverUrl" :src="ruleForm.coverUrl" class="avatar" />
		            	<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		          	</el-upload>
		        </el-form-item>
		        <el-form-item label="封面宽度" prop="coverWidth">
		          	<el-input v-model="ruleForm.coverWidth" style="width: 80%;"></el-input>
		        </el-form-item>
				<el-form-item label="封面高度" prop="coverHeight">
		          	<el-input v-model="ruleForm.coverHeight" style="width: 80%;"></el-input>
		        </el-form-item>
		        
      		</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit()">确 定</el-button>
		    </span>
    	</el-dialog>

    	<!-- 选择教练弹框 -->
	    <el-dialog title="选择教练" :visible.sync="dialogVisible2" width="35%" :before-close="handleClose2">
	      	<el-scrollbar style="height:500px; width:100%;cursor:pointer">
	        	<template>
	          		<el-table ref="multipleTable" :data="coachesData" highlight-current-row tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange2">
		            	<el-table-column prop="id" align="center" label="ID"></el-table-column>
		            	<el-table-column prop="nickName" align="center" label="名字" show-overflow-tooltip></el-table-column>
	          		</el-table>
	        	</template>
		        <div class="block" style="padding:30px 10px; float:right">
		          	<el-pagination @current-change="handleCurrentChangePage2" :current-page="paramcoach.pageNum" :page-size="paramcoach.limit" layout="total, prev, pager, next, jumper" :total="totalPage2"></el-pagination>
		        </div>
	      	</el-scrollbar>
	    </el-dialog>

	    <el-dialog title="视频" :visible.sync="dialogVisible3" width="35%" :before-close="handleClose">
	    	<div style="max-height:500px;max-width:100%; text-align:center">
	      		<video :src="videoUrl" controls="controls" loop="-1" style="max-height:500px;max-width:100%;"></video>
	      	</div>
	    </el-dialog>

	    <!-- 评论 -->
	    <el-dialog title="评论" :visible.sync="dialogVisible4" width="35%" :before-close="handleClose">
	    	<div class="commentReply" style="max-height:300px;overflow-y:scroll; margin-top:-20px">
	    		<div v-for="(item,index) in commentReply" class="commentReplyItem" >
	    			<div class="img" @click="levelOneComment(item.userName,item.id)"><img :src="item.userPhoto?item.userPhoto:'https://www.xqiaohome.com/images/favicon.jpg'"></div>
	    			<div>
	    				<div class="userName" 
	    					@click="levelOneComment(item.userName,item.id)">{{item.userName}}</div>
	    				<div class="comment" 
	    					@click="levelOneComment(item.userName,item.id)">{{item.comment}}<span>{{item.createTime | timeago}}</span><i @click.stop="soldOut(item.id,item.state,index,0)">{{item.state==0?'下架':'上架'}}</i></div>
	    				<div v-for="(items,indexs) in item.getCommentReplydata" 
	    					class="commentReplyItem commentReplyItem2">
	    					<div class="img img2" 
	    						@click="levelOneComment(items.userName,item.id,items.userId)"><img :src="items.userPhoto?items.userPhoto:'https://www.xqiaohome.com/images/favicon.jpg'"></div>
	    					<div>
	    						<div class="userName" 
	    							@click="levelOneComment(items.userName,item.id,items.userId)">{{items.userName}}</div>
	    						<div class="comment" 
	    							@click="levelOneComment(items.userName,item.id,items.userId)">{{items.replyuserName?'回复'+items.replyuserName+'：':''}}{{items.comment}}<span>{{items.createTime | timeago}}</span><i @click.stop="soldOut(items.id,items.status,index,1,indexs)">{{items.status==0?'下架':'上架'}}</i></div>
	    					</div>
	    				</div>
	    				<div class="unfold" v-if="item.hasNextPage==false" @click="packup(index)">收起</div>
	    				<div class="unfold" @click="nextPage(item.id,item.nextPage,index)" v-if="item.hasNextPage==true && item.nextPage>0">查看更多回复</div>
	    				<div class="unfold" v-if="item.secondCommentCount>0 && item.spread==false" @click="getCommentReply(item.id,index,item.spread)">——展开{{item.secondCommentCount}}条回复</div>

	    			</div>
	    			
	    		</div>
	    	</div>
	    	<div class="block" style="padding:0px 10px; float:right" v-if="totalPage4>0">
	          	<el-pagination @current-change="handleCurrentChangePage4" :current-page="pageNum4" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage4"></el-pagination>
	        </div>
	        
	    	<div class="texter">
	    		<textarea :placeholder="complaceholder" v-model="content" name="emoji" class="emoji_textarea"></textarea>
	    		<!-- // -->
				<picker
					:style="{width:'100%',height:'100px'}"
			      	:include="['people']"
			      	:showSearch="false"
			      	:showPreview="false"
			      	:showCategories="false"
			      	@select="addEmoji"
			    />
			    
	    		<el-button type="primary" style="margin-top:20px" @click="sendComment">发送</el-button>
	    	</div>
	    	
	    </el-dialog>

	</div>
</template>
<script>
import { Picker } from 'emoji-mart-vue';
export default {
	components: {
		Picker
	},
  	mounted() {
  		this.init();	
  	},
  	data() {
    	return {
    		content: '',
      		comment: '',
    		sysRoleId:localStorage.getItem("sysRoleId"),
    		setcoachId:localStorage.getItem("setcoachId"),
    		paramvideo:{
    			pageNum: 1,
        		limit: 20
    		},//选择教练参数配置
    		pageNum: 1,
		    limit: 10,
		    totalPage: 10,
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
	      	tmpFiles: process.env.API_ROOT + "/tmpFiles",
	      	tmpFilesv: process.env.API_ROOT + "/tmpFiles?type=2",
	      	tableData3: [],
	        dialogVisible: false,
	        ruleForm: {
	        	videoDesc:'',
		        videoUrl:'',
		        nickname: "点击选择",
		        coverUrl:'',
		        coverWidth:'',
		        coverHeight:''
		    },
		    ruleForms: {
		        coachId: [{ required: true, message: "请选择教练",trigger: 'blur'}],
		        videoUrl: [{ required: true, message: "请上传视频",trigger: 'blur' }],
		        coverUrl: [{ required: true, message: "请选择封面" ,trigger: 'blur'}],
		        coverWidth: [{ required: true, message: "请填写封面宽度",trigger: 'blur' }],
		        coverHeight: [{ required: true, message: "请填写封面高度" ,trigger: 'blur'}],
		    },
		    videoFlag: false, //刚开始的时候显示为flase
		    videoUploadPercent: "0%", //进度条刚开始的时候为0%
		    dialogVisible2: false,
		    coachesData: [], //教练列表
		    paramcoach:{
    			pageNum: 1,
        		limit: 10
    		},//选择教练参数配置
    		isShow: false,
    		totalPage2: 10,
    		dialogVisible3:false,
    		videoUrl:'',
    		currentRow:'',
    		searchVideo:'',//15分钟法特莱克变速跑
    		timeVal:'',
    		cur:0,
    		selData:[
    			{name:'全部',id:0},
    			{name:'审核不通过',id:1},
    			{name:'待审核',id:2},
    			{name:'审核通过',id:3}
    		],
    		status:0,
    		dialogVisible4:false,
    		commentReply:[],
    		totalPage4:10,
    		answerId:'',//评论id
    		pageNum4:1,//一级评论
    		pageNum5:1,//二级评论
    		complaceholder:'有爱评论，请说点好听的~',
    		commentId:'',//一级视频id
    		replyuserId:'',//被回复用户ID
	    };
  	},
  	filters: {
	    timeago(dateTimeStamp){   
			// dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
	        var minute=1000*60;      //把分，时，天，周，半个月，一个月用毫秒表示
	        var hour=minute*60;
	        var day=hour*24;
	        var week=day*7;
	        var halfamonth=day*15;
	        var month=day*30;
	        var now=new Date().getTime();   //获取当前时间毫秒
	        var diffValue=now - dateTimeStamp;//时间差
	        if(diffValue<0){return;}
	        var  minC=diffValue / minute;  //计算时间差的分，时，天，周，月
	        var  hourC=diffValue / hour;
	        var  dayC=diffValue / day;
	       	var  weekC=diffValue / week;     
	        var  monthC=diffValue / month,result;
 
	       	if(monthC>=1){
				result="" + parseInt(monthC) + "月前";
			}
			else if(weekC>=1){
				result="" + parseInt(weekC) + "周前";
			}
			else if(dayC>=1){
				result=""+ parseInt(dayC) +"天前";
			}
			else if(hourC>=1){
				result=""+ parseInt(hourC) +"小时前";
			}
			else if(minC>=1){
				result=""+ parseInt(minC) +"分钟前";
			}else{
				result="刚刚";
			}
			
			return result;
		},
  	},
  	methods:{
  		addEmoji(e){
	      	this.content += e.native
	    },
	    sendComment(row){//发送评论
	    	if(this.content){
	    		var params = {
	        		answerId:this.commentId?this.commentId:this.answerId,
	        		userId:localStorage.getItem("userId"),
	        		comment:this.content,
	        		isParentComment:this.commentId?1:0,
	        		replyuserId:this.replyuserId
	      		};
	      		console.log(params)
				this.$post("/shortVideo/addShortVideoComments", JSON.stringify(params))
	        	.then(res => {
	        		console.log(res)
	          		if (res.code == 0) {
	            		this.$message({
		                    message: "操作成功",
		                    type: "success"
	                  	});
	                  	this.$refs.multipleTable.setCurrentRow(row);
	                  	this.pageNum4=1;
	                  	this.currentRow='';
	                  	this.dialogVisible4=false;
	                  	this.content='';
	                  	this.commentId='';
	                  	this.complaceholder='有爱评论，请说点好听的~',
    					this.replyuserId='';
	          		} else {
	            		this.$message({
	              			message: res.message,
	              			type: "warning"
	            		});
	            		return false;
	          		}
	        	})
	    	}else{
	    		this.$message({
          			message: '请输入评论',
          			type: "warning"
        		});
        		return false;
	    	}
	    },
  		init(){//视频列表
  			var params = {
        		pageNum: this.pageNum,
        		limit: this.limit,
        		userId:localStorage.getItem("userId"),
        		searchVideo:this.searchVideo,
        		startCreateTime:this.timeVal?this.timeVal[0].valueOf():'',
        		endCreateTime:this.timeVal?this.timeVal[1].valueOf():'',
        		status:this.status
      		};
      		this.$get("/shortVideo/searchShortVideoList", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.tableData3 = res.data.list;
            		this.totalPage = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
        	.catch(() => {
          		console.log();
        	});
  		},
  		topnav(e,id){
	    	this.status=id;
	    	this.pageNum=1;
 			this.cur=e;
 			this.init();
 		},
  		search_mine(){
  			this.pageNum=1;
  			this.init();
  		},
  		//添加
	    add(row) {
	    	this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs["ruleForm"]) {
	        	this.$refs["ruleForm"].resetFields();
	      	}
	      	console.log(this.setcoachId)
	      	if(this.setcoachId!='undefined'){
	  			this.ruleForm.nickname=localStorage.getItem("nickname");
	  			this.ruleForm.coachId=this.setcoachId;
	  			//this.ruleForm.userId=localStorage.getItem("userId")
	  		}else{
	  			this.ruleForm.nickname='点击选择'
	  			this.ruleForm.coachId=''
	  		}
	  		this.currentRow='';
	      	this.dialogVisible = true;
	      	this.selCoachesData()
	    },
	    checkShortVideo(row,type){
			if(row.id){
				var params = {
	        		checkType:type,
	        		userId:localStorage.getItem("userId"),
	        		videoId:row.id
	      		};
				this.$post("/shortVideo/checkShortVideo", JSON.stringify(params))
	        	.then(res => {
	        		console.log(res)
	          		if (res.code == 0) {
	            		this.$message({
		                    message: "操作成功",
		                    type: "success"
	                  	});
	                  	this.pageNum=1;
	                  	this.currentRow='';
	                  	this.init();
	          		} else {
	            		this.$message({
	              			message: res.message,
	              			type: "warning"
	            		});
	            		return false;
	          		}
	        	})
			}
	    },
	    //弹框关闭按钮
	    handleClose(done,row) {
	      	// if (this.$refs.ruleForm != undefined) {
	       //  	this.$refs.ruleForm.resetFields();
	      	// }
	      	this.$refs.multipleTable.setCurrentRow(row);
          	this.pageNum4=1;
          	this.currentRow='';
          	this.videoUrl='';
          	this.commentId='';
          	this.content='';
          	this.complaceholder='有爱评论，请说点好听的~',
    		this.replyuserId='';
	      	done();
	    },
	    comments(row){
	    	this.answerId=row.id;
	    	this.getShortVideoComments();
	    },
	    getShortVideoComments(){//一级评论
	    	var params = {
        		pageNum: this.pageNum4,
        		limit: this.limit,
        		userId:localStorage.getItem("userId"),
        		videoId:this.answerId
      		};
      		this.$get("/shortVideo/getShortVideoComments", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		for(var i=0;i<res.data.list.length;i++){
            			res.data.list[i].spread=false;
            			res.data.list[i].getCommentReplydata=[];
            			res.data.list[i].hasNextPage=true;
            			res.data.list[i].nextPage=0;
            		}
            		this.commentReply = res.data.list;
            		this.totalPage4 = res.data.total;
            		this.dialogVisible4=true;
            		console.log(this.commentReply)
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
	    },
	    getCommentReply(id,index,spread){//二级评论
	    	if(spread==false){
	    		var params = {
	        		pageNum: this.pageNum5,
	        		limit: this.limit,
	        		userId:localStorage.getItem("userId"),
	        		commentId:id
	      		};
	      		this.$get("/shortVideo/getShortVideoCommentReply", params)
	        	.then(res => {
	        		console.log(res)
	          		if (res.code == 0) {
	          			this.commentReply[index].getCommentReplydata=res.data.list;
	          			this.commentReply[index].hasNextPage=res.data.hasNextPage;
	          			this.commentReply[index].nextPage=res.data.nextPage
	          			this.commentReply[index].spread=true;
	          			console.log(this.commentReply)
	          		} else {
	            		this.$message({
	              			message: res.message,
	              			type: "warning"
	            		});
	            		return false;
	          		}
	        	})
	    	}else{
	    		this.commentReply[index].spread=false;
	    		this.commentReply[index].getCommentReplydata=[]
	    	}	
	    },
	    soldOut(commentId,soldOut,index,isParentComment,indexs){
	    	var params = {
        		commentId:commentId,
        		isParentComment:isParentComment,
        		soldOut:soldOut==0?1:0,
      		};
			this.$post("/shortVideo/shortVideoCommentSoldOut", JSON.stringify(params))
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
          			if(isParentComment==0){
			    		this.commentReply[index].state = soldOut==0?1:0;
			    	}else{
			    		this.commentReply[index].getCommentReplydata[indexs].status = soldOut==0?1:0;
			    	}
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})	
	    },
	    levelOneComment(name,commentId,replyuserId){
	    	this.complaceholder='回复@'+name;
	    	console.log(replyuserId)
	    	if(commentId){
	    		this.commentId=commentId
	    	}else{
	    		this.commentId=''
	    	}
	    	if(replyuserId){
	    		this.replyuserId=replyuserId
	    	}else{
	    		this.replyuserId=''
	    	}

	    },
	    packup(index){
	    	this.commentReply[index].hasNextPage=true;
	    	this.commentReply[index].spread=false;
	    	this.commentReply[index].getCommentReplydata=[]
	    },
	    nextPage(id,page,index){
	    	if(page>0){
	    		var params = {
	        		pageNum: page,
	        		limit: this.limit,
	        		userId:localStorage.getItem("userId"),
	        		commentId:id
	      		};
	      		this.$get("/shortVideo/getShortVideoCommentReply", params)
	        	.then(res => {
	        		console.log(res)
	          		if (res.code == 0) {
	          			for(var i=0;i<res.data.list.length;i++){
	            			this.commentReply[index].getCommentReplydata.push(res.data.list[i]);
	            		}
	          			this.commentReply[index].hasNextPage=res.data.hasNextPage;
	          			this.commentReply[index].nextPage=res.data.nextPage;
	          			console.log(this.commentReply)
	          		} else {
	            		this.$message({
	              			message: res.message,
	              			type: "warning"
	            		});
	            		return false;
	          		}
	        	})
	    	}
	    },
  		del(){
  			var that = this;
	      	if (that.currentRow.id) {
	        	that.$confirm("确定要删除吗?", "提示", {
		            confirmButtonText: "确定",
		            cancelButtonText: "取消",
		            type: "warning"
	          	})
	          	.then(() => {
	            	var params = {
	            		videoId:that.currentRow.id,
		        		userId:that.currentRow.userId
		      		};
	            	this.$post("/shortVideo/deleteShortVideo",JSON.stringify(params))
	              	.then(function(res) {
	                	console.log(res);
	                		if (res.code == 0) {
			                  	that.$message({
				                    message: "删除成功",
				                    type: "success"
			                  	});
			                  	that.pageNum=1;
			                  	that.currentRow='';
			                  	that.init();
	                		} else {
	                  			that.errorMsg("操作失败");
	                		}
	              	})
	              	.catch(function(err) {
	                	console.log(err);
	              	});
	          	})
	          	.catch(() => {});
	      	} else {
		        this.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
  		},
	    //当前页数
	    handleCurrentChangePage(val) {
	    	this.pageNum = val;
	      	this.init()
	    },
	    //视频
	    beforeUploadVideo(file) {
	      	const ismp4 = file.type === "video/mp4";
	      	var that=this;
	      	if (!ismp4) {
	        	that.$message.error("上传头像图片只能是 mp4 格式!");
	      	}
	      	var fileName = file.name || "";
      		var ext = fileName.split(".")[fileName.split(".").length - 1];
	      	if (ext == "mp4") {
		        // 获取视频时长
		        var url = URL.createObjectURL(file);
		        var audioElement = new Audio(url);
		        var duration;
		        audioElement.addEventListener("loadedmetadata", function(_event) {
		          	duration = audioElement.duration; //时长为秒，小数，182.36
		          	console.log(parseInt(duration));
		          	setTimeout(function(){ 
		          		that.ruleForm.videoSeconds=parseInt(duration)
		          	}, 1000);
		        });
		    }
	      	return ismp4; 	
	    },
	    handleVideoSuccess(response, file, fileList) {
	      	//视频上传成功之后返回视频地址
	      	this.videoFlag = false;
	      	this.videoUploadPercent = 0;
	      	this.ruleForm.videoUrl = response.data.url;
	    },
	    uploadVideoProcess(event, file, fileList) {
	      	//视频上传的时候获取上传进度传给进度条
	      	this.videoFlag = true;
	      	this.videoUploadPercent = parseInt(file.percentage);
	      	//console.log(this.videoUploadPercent);
	    },
	    //选择图片成功
	    handleAvatarSuccess(res, file) {
	    	if(res.data.url){
	    		this.ruleForm.coverUrl = res.data.url;
	    	}
	    },
	    beforeAvatarUpload(file) {
	      	const isPng = file.type === "image/png";
	      	const isLt2M = file.size / 1024 < 25;
	      	if (!isPng) {
	        	this.$message.error("上传头像图片只能是 png 格式!");
	      	}
	      	if (!isLt2M) {
	        	this.$message.error("上传头像图片大小不能超过 25kb!");
	      	}
	      	return isPng && isLt2M;
	    },
	    //点击选择教练
	    selCoachesDialog() {
	      	this.dialogVisible2 = true;
	    },
	    handleClose2() {
	      	this.dialogVisible2 = false
	    },
	    //选择教练
	    selCoachesData() {
	      	let params = this.paramcoach;
	      	this.$get("/coaches", params)
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
		            this.coachesData = res.data.list;
		            this.totalPage2 = res.data.total;
	          	} else {
	            	this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
	            	return false;
	          	}
	        })
	        .catch(() => {
	          console.log();
	        });
	    },
	    //点击选择用户行
	    handleCurrentChange2(val) {
	      	this.dialogVisible2 = false
	      	if (val) {
	        	this.ruleForm.coachId = val.id;
	        	this.ruleForm.nickname = val.nickName;
	      	}
	    },
	    //当前教练页数
	    handleCurrentChangePage2(val) {
	      	this.paramcoach.pageNum = val;
	      	this.selCoachesData();
	    },
	    handleCurrentChangePage4(val){//评论分页
	    	this.pageNum4=val;
	    	this.getShortVideoComments();
	    },
	    watchVideo(url){
	    	if(url){
	    		this.dialogVisible3 = true
	    		this.videoUrl=url
	    	}
	    },
	    handleCurrentChange(val) {
	      	if (val) {
		        this.currentRow = val;
	      	}
	    },
	    videoStick(row){
	    	var params = {
        		videoId: row.id,
        		setTop: row.isTop==0?1:0
      		};
	    	this.$post("/shortVideo/addShortVideoStick",JSON.stringify(params))
	        .then(res => {
	          	if (res.code == 0) {
		            this.$message({
		              	message: "操作成功",
		              	type: "success"
		            });
		            this.pageNum=1;
		            this.init();
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
	        })
	    },
	    onSubmit(){
	    	this.ruleForm.videoWidth=this.ruleForm.coverWidth;
	    	this.ruleForm.videoHeight=this.ruleForm.coverHeight;
	    	if(!this.ruleForm.coachId){
	    		this.$message({
	              	message: "请选择教练",
	              	type: "warning"
	            });
	            return false
	    	}else if(!this.ruleForm.videoUrl){
	    		this.$message({
	              	message: "请上传视频",
	              	type: "warning"
	            });
	            return false
	    	}else if(!this.ruleForm.coverUrl){
	    		this.$message({
	              	message: "请上传封面",
	              	type: "warning"
	            });
	            return false
	    	}else if(!this.ruleForm.coverWidth){
	    		this.$message({
	              	message: "请填写封面宽度",
	              	type: "warning"
	            });
	            return false
	    	}else if(!this.ruleForm.coverHeight){
	    		this.$message({
	              	message: "请填写封面高度",
	              	type: "warning"
	            });
	            return false
	    	}else{
	    		this.$post("/shortVideo/addShortVideoDetail",JSON.stringify(this.ruleForm))
		        .then(res => {
		          	if (res.code == 0) {
			            this.$message({
			              	message: "保存成功",
			              	type: "success"
			            });
			            this.dialogVisible = false;
			            this.pageNum=1;
			            this.searchVideo='';
        				this.timeVal='';
			            this.init();
		          	} else {
			            this.$message({
			              	message: res.message,
			              	type: "warning"
			            });
			            return false;
		          	}
		        })
		        .catch(() => {
		          	console.log();
		        });
	    	}
	    	
	    }
  	}
}
</script>
<style scoped>
::deep
.avatar-uploader-icon {
    width: 108px;
    line-height: 108px
}
.selectUser {
  color: #409eff;
}
.selectUser label,
.selectUser i {
  	font-size: 12px;
}
.stagetit{
	font-size: 15px;
	text-align: center;
	font-weight: bold;
	margin-bottom: 5px
}
.stagetit span{
	padding: 0 10px
}
::deep
.stagecon .el-dialog__body{
	padding: 10px 20px;
}
::deep
.el-date-editor .el-range-separator{
	padding: 0
}
.searchBtn .el-range-editor.el-input__inner{
	margin: 0 15px
}
.topinput{
	position: relative;
	margin-left: 15px;
	width: 250px
}
.topinput input{
	font-size: 13px;
}


.imgWidth{
	width: 50px;
	height: 50px;
	border:1px solid #ccc;
	display:flex;
  	align-items:center;
}
.imgWidth img,.avatar{
	max-width: 100%;
}
::deep
.el-date-editor .el-range-separator{
	padding: 0
}
.searchBtn .el-range-editor.el-input__inner{
	margin: 0 15px
}
/*评论*/
.commentReplyItem{
	display: flex;
	color: #4D5260;
	font-size: 12px;
	margin-bottom: 15px;
	cursor:pointer;
}
.commentReplyItem .img img{
	max-width: 40px;
	height: 40px;
	border-radius: 50%;
	margin-right: 10px
}
.commentReplyItem2{
	margin: 10px 0 0
}
.commentReplyItem .img2 img{
	max-width: 30px;
	height: 30px;
}
.commentReplyItem .comment{
	color: #05091B;
	font-size: 13px;
	margin-top: 7px;
	line-height: 22px
}
.comment span{
	color: #9EA0A8;
	margin-left:10px;
}
.comment i{
	margin-left:10px;
}
.unfold{
	color: #9EA0A8;
	margin-top: 10px;
	cursor: pointer;
}
.emoji_textarea{
	width:100%;
	padding:5px;
	min-height:70px; 
	margin:10px 0;
	font-family: "微软雅黑";
}


::deep
.emoji-mart-category-label{
  display: none
}
</style>


// WEBPACK FOOTER //
// src/views/videoList/index.vue